import React from 'react'

function DashboardLoader({ text = 'Cargando...', size = 'md', inline = false }) {
  return (
    <span className={`dashboard-loader ${inline ? 'inline' : ''} ${size === 'sm' ? 'small' : ''}`} role="status" aria-live="polite">
      <span className="dashboard-loader-spinner" aria-hidden="true" />
      <span>{text}</span>
    </span>
  )
}

export default DashboardLoader
